// extracted by mini-css-extract-plugin
export default {"formItem":"FormItem_form-item__8i4Ua"};